import React from "react";
import { Stack, Text, Title } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
export const CheckinHeader = ({ segment }) => {
    const i18n = useI18n();
    return (React.createElement(Stack, { gap: 2 },
        React.createElement(Title, { variant: "headline_1", title: i18n.trans(t("flights_pb_checkin_header", {
                variables: {
                    destination_city: segment.arrivalAirport.cityName || ""
                }
            })) }),
        React.createElement(Text, { variant: "body_1", color: "neutral_alt" }, i18n.trans(t("flights_pb_checkin_subhead")))));
};
